const styleSheet = () => ({
  container: {
    width: '310px',
    '& #number-section': {
      marginBottom: 0,
    },
  },
  section: {
    '& :last-child': {
      marginBottom: 0,
    },
  },
  sectionHeader: {
    height: '10px',
    color: '#051D39',
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '19px',
    paddingBottom: '40px',
  },
  sectionItem: {
    marginBottom: '10px',
    marginLeft: '10px',
  },
  sectionItemLabel: {
    marginBottom: '5px',
    height: '15px',
    width: '100%',
    color: '#6373A4',
    fontSize: '11px',
    fontWeight: '500',
    lineHeight: '15px',
  },
  sectionItemInfo: {
    width: '100%',
    color: '#051D39',
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '19px',
    wordWrap: 'break-word',
  },
  sectionItemInfoNull: {
    height: '19px',
    width: '6px',
    color: '#051D39',
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '14px',
    fontWeight: '500',
    lineHeight: '19px',
  },
  lineBreak: {
    backgroundColor: '#D8DCE6',
    width: '100%',
    margin: '16px auto',
    height: '1px',
  },
});

export default styleSheet;
